import { useQuery } from '@tanstack/react-query';
import { listTapChangeLog } from '../api/client';

export function useTapChangeLog(params: {
  locationId?: string;
  offset?: number;
  limit?: number;
}) {
  return useQuery({
    queryKey: ['tap-change-log', params.locationId ?? null, params.offset ?? 0, params.limit ?? null],
    queryFn: () => listTapChangeLog(params),
    staleTime: 30_000,
    placeholderData: (prev) => prev,
  });
}
